<div class="inner-content"
    [style.justify-content]="justify"
    [style.align-items]="align">
    <ng-content></ng-content>
</div>